import { CheckCircle2, Info, X, XCircle } from 'lucide-react';
import { useEffect } from 'react';
import { useAppStore } from '../stores/app-store';
import styles from './Notice.module.css';

export function Notice() {
  const notice = useAppStore((state) => state.notice);
  const clear = useAppStore((state) => state.clearNotice);
  useEffect(() => {
    if (!notice) return;
    const timer = window.setTimeout(clear, 5000);
    return () => window.clearTimeout(timer);
  }, [notice, clear]);
  if (!notice) return null;
  const Icon = notice.kind === 'success' ? CheckCircle2 : notice.kind === 'error' ? XCircle : Info;
  return <div className={`${styles.notice} ${styles[notice.kind]}`} role="status"><Icon size={19} /><span>{notice.message}</span><button type="button" onClick={clear} aria-label="Dismiss"><X size={17} /></button></div>;
}
